// NOTE: If you are adding a new color variable, please add it to /common/_colors3.less
// to make sure they are in sync

// All Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=1305%3A21630
const COLOR_BAY_100 = '#0f5c82';
const COLOR_BLACK_005 = '#f3f3f3';
const COLOR_BLACK_015 = '#dbdbdb';
const COLOR_BLACK_030 = '#b7b7b7';
const COLOR_BLACK_050 = '#757575';
const COLOR_BLACK_075 = '#4a4a4a';
const COLOR_BLACK_100 = '#0e0e0e';
const COLOR_BLUSH_100 = '#ffebf8';
const COLOR_CLOUD_100 = '#f9f9f9';
const COLOR_COVE_100 = '#55a1bf';
const COLOR_FOREST_100 = '#005759';
const COLOR_GRAY_100 = '#868686';
const COLOR_LILAC_100 = '#d9cafc';
const COLOR_MARINE_100 = '#183b54';
const COLOR_MINT_100 = '#d7f5d9';
const COLOR_ORANGE_PEEL_100 = '#ff9a00';
const COLOR_ROSE_005 = '#fbf2f5';
const COLOR_ROSE_030 = '#e9b2c3';
const COLOR_ROSE_075 = '#c94c71';
const COLOR_ROSE_100 = '#c7305b';
const COLOR_SKY_100 = '#89fafc';
const COLOR_WHITE_100 = '#ffffff';
const COLOR_WINE_100 = '#77133f';

const COLORS = {
  BAY_100: COLOR_BAY_100,
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075,
  BLACK_100: COLOR_BLACK_100,
  BLUSH_100: COLOR_BLUSH_100,
  CLOUD_100: COLOR_CLOUD_100,
  COVE_100: COLOR_COVE_100,
  FOREST_100: COLOR_FOREST_100,
  GRAY_100: COLOR_GRAY_100,
  LILAC_100: COLOR_LILAC_100,
  MARINE_100: COLOR_MARINE_100,
  MINT_100: COLOR_MINT_100,
  ROSE_005: COLOR_ROSE_005,
  ROSE_030: COLOR_ROSE_030,
  ROSE_075: COLOR_ROSE_075,
  ROSE_100: COLOR_ROSE_100,
  SKY_100: COLOR_SKY_100,
  WHITE_100: COLOR_WHITE_100,
  WINE_100: COLOR_WINE_100,
} as const;

// Brand Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=3%3A9
export const COLORS_BRAND = {
  BOLD_BAY_100: COLOR_BAY_100,
  BOLD_CLOUD_100: COLOR_CLOUD_100,
  BOLD_COVE_100: COLOR_COVE_100,
  BOLD_FOREST_100: COLOR_FOREST_100,
  BOLD_MARINE_100: COLOR_MARINE_100,
  BOLD_ROSE_100: COLOR_ROSE_100,
  BOLD_WINE_100: COLOR_WINE_100,
  SECONDARY_BLUSH_100: COLOR_BLUSH_100,
  SECONDARY_LILAC_100: COLOR_LILAC_100,
  SECONDARY_MINT_100: COLOR_MINT_100,
  SECONDARY_SKY_100: COLOR_SKY_100,
} as const;

// Neutral Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=52%3A539
export const COLORS_NEUTRALS = {
  BLACK_100: COLOR_BLACK_100,
  GRAY_100: COLOR_GRAY_100,
  WHITE_100: COLOR_WHITE_100,
} as const;

// Gray Colors
// https://www.figma.com/file/jJD0yd6vihUIjhhnplwDkw/Zola-PD-Master-Library-v3?node-id=1305%3A21630
export const COLORS_GRAYS = {
  BLACK_005: COLOR_BLACK_005,
  BLACK_015: COLOR_BLACK_015,
  BLACK_030: COLOR_BLACK_030,
  BLACK_050: COLOR_BLACK_050,
  BLACK_075: COLOR_BLACK_075,
} as const;

// Semantic Colors
export const COLORS_SEMANTIC = {
  ERROR_005: COLOR_ROSE_005,
  ERROR_030: COLOR_ROSE_030,
  ERROR_075: COLOR_ROSE_075,
  ERROR_100: COLOR_ROSE_100,
  INFO_100: COLOR_WINE_100,
  SUCCESS_100: COLOR_FOREST_100,
  WARNING_100: COLOR_ORANGE_PEEL_100,
} as const;

export default COLORS;
